import SampleComponent from './SampleComponent';
import AnimateNumber from './AnimateNumber';
import Chart from './Chart';
import ChartControl from './ChartControl';
import Flickity from './Flickity';
import InViewport from './InViewport';
import HomepageCarousel from './HomepageCarousel';
import HomepageResults from './HomepageResults';
import StationOpener from './StationOpener';
import StationDetail from './StationDetail';
import ScrollTo from './ScrollTo';
import Unfold from './Unfold';
import MenuToggle from './MenuToggle';
import FilterArticles from './FilterArticles';
import CallOpener from './CallOpener';

const Components = {
    SampleComponent: SampleComponent,
    AnimateNumber: AnimateNumber,
    CallOpener: CallOpener,
    Chart: Chart,
    ChartControl: ChartControl,
    Flickity: Flickity,
    InViewport: InViewport,
    HomepageCarousel: HomepageCarousel,
    HomepageResults: HomepageResults,
    StationOpener: StationOpener,
    StationDetail: StationDetail,
    ScrollTo: ScrollTo,
    Unfold: Unfold,
    MenuToggle: MenuToggle,
    FilterArticles: FilterArticles
};

export default Components;



// WEBPACK FOOTER //
// ./components/index.js